/* TWD — Best Sellers carousel pagination (progress rail, styled in custom.css §17).
   Math.abs on scrollLeft handles the negative values WebKit uses in RTL. */
function twdCarouselDots() {
  document.querySelectorAll('slideshow-slides').forEach((scroller) => {
    if (!scroller.querySelector(':scope > .resource-list__slide')) return;
    const host = scroller.closest('slideshow-container') || scroller.parentElement;
    if (!host || host.querySelector(':scope > .twd-dots')) return;
 
    const slides = [...scroller.querySelectorAll(':scope > .resource-list__slide')];
    if (slides.length < 2) return;
 
    const nav = document.createElement('div');
    nav.className = 'twd-dots';
    nav.setAttribute('role', 'tablist');
    nav.setAttribute('aria-label', 'Carousel pages');
    host.appendChild(nav);
 
    let step = 1, pages = 1;
 
    const measure = () => {
      const w = slides[0].getBoundingClientRect().width;
      const gap = parseFloat(getComputedStyle(scroller).columnGap) || 0;
      step = Math.max(1, Math.round(scroller.clientWidth / (w + gap)));
      pages = Math.ceil(slides.length / step);
      nav.innerHTML = '';
      for (let i = 0; i < pages; i++) {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'twd-dot';
        b.setAttribute('role', 'tab');
        b.setAttribute('aria-label', `Page ${i + 1} of ${pages}`);
        b.addEventListener('click', () => {
          slides[i * step].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
        });
        nav.appendChild(b);
      }
      nav.hidden = pages < 2;
      sync();
    };
 
    const sync = () => {
      const w = slides[0].getBoundingClientRect().width;
      const gap = parseFloat(getComputedStyle(scroller).columnGap) || 0;
      // Math.abs handles negative scrollLeft values generated in WebKit RTL mode
      const scrollPos = Math.abs(scroller.scrollLeft);
      const i = Math.min(pages - 1, Math.round(scrollPos / ((w + gap) * step)));
      [...nav.children].forEach((d, n) => {
        d.classList.toggle('is-active', n === i);
        d.setAttribute('aria-selected', n === i);
      });
    };
 
    scroller.addEventListener('scroll', () => {
      clearTimeout(scroller._twdT);
      scroller._twdT = setTimeout(sync, 60);
    }, { passive: true });
 
    new ResizeObserver(measure).observe(scroller);
    measure();
  });
}
 
document.addEventListener('DOMContentLoaded', twdCarouselDots);
document.addEventListener('shopify:section:load', twdCarouselDots);
 
 
 
 
 
 
 
/* Product specs — split the multi-line metafield into a label/value list */
(function () {
  function buildSpecs(scope) {
    (scope || document)
      .querySelectorAll('.metafield-multi_line_text_field')
      .forEach(function (el) {
        if (el.closest('.twd-spec')) return;
 
        var lines = el.innerHTML
          .split(/<br\s*\/?>/i)
          .map(function (s) { return s.replace(/<[^>]*>/g, '').trim(); })
          .filter(Boolean);
 
        // only convert when it really is a spec list
        if (lines.length < 3) return;
        if (!lines.every(function (l) { return l.indexOf(':') > 0; })) return;
 
        var dl = document.createElement('dl');
        dl.className = 'twd-spec';
 
                lines.forEach(function (line) {
          var i = line.indexOf(':');
          var dt = document.createElement('dt');
          var dd = document.createElement('dd');
          dt.textContent = line.slice(0, i).trim();
          var val = document.createElement('span');
          val.dir = 'auto';
          val.textContent = line.slice(i + 1).trim();
          dd.appendChild(val);
 
          if (/case\s*diameter|قطر\s*(العلبة|الهيكل)/i.test(dt.textContent)) {
            var root =
              (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
            var a = document.createElement('a');
            a.className = 'twd-spec__link';
            a.href = root + 'pages/size-guide';
            a.textContent = document.documentElement.dir === 'rtl' ? 'دليل المقاسات ←' : 'Size guide →';
            dd.appendChild(a);
          }
 
          dl.appendChild(dt);
          dl.appendChild(dd);
        });
 
        var target = el.closest('p') || el;
        target.parentNode.replaceChild(dl, target);
      });
  }
 
  if (document.readyState !== 'loading') buildSpecs(document);
  document.addEventListener('DOMContentLoaded', function () { buildSpecs(document); });
  document.addEventListener('shopify:section:load', function (e) { buildSpecs(e.target); });
})();
 
 
/* ==========================================================
   TWD variant picker — heal an impossible selection
 
   Sparse variant matrices: The Apex Racer sells Case x Dial, but
   Silver has no Gold dial. Dwell keeps the previous Dial when you
   change Case, so the picker sits on Silver + Gold — a combination
   with no variant. Price hides, the button reads UNAVAILABLE, and
   custom.css section 10 hides the checked button, so the shopper
   cannot even see or re-click what is selected.
 
   This selects the first option value that actually has a variant
   whenever the checked one does not. VariantPicker morphs itself
   after every fetch, so act only once the morph has settled, re-query
   the inputs at that point rather than holding stale references, and
   dispatch change so VariantPicker's own listener runs.
 
   Cannot loop: once a value with a variant is checked, the next pass
   hits the continue and stops.
   ========================================================== */
(function () {
  if (window.Shopify && window.Shopify.designMode) return;
 
  var SETTLE_MS = 80;
 
  function heal(picker) {
    var fieldsets = picker.querySelectorAll('fieldset[data-fieldset-index]');
 
    for (var f = 0; f < fieldsets.length; f++) {
      var fs = fieldsets[f];
 
      // Fieldset 0 drives the others and is never filtered.
      if (fs.dataset.fieldsetIndex === '0') continue;
 
      var inputs = Array.prototype.slice.call(
        fs.querySelectorAll('input[type="radio"]')
      );
 
      var checked = null;
      var valid = null;
 
      for (var i = 0; i < inputs.length; i++) {
        if (inputs[i].checked) checked = inputs[i];
        if (
          !valid &&
          inputs[i].dataset.variantId &&
          inputs[i].dataset.optionAvailable === 'true'
        ) {
          valid = inputs[i];
        }
      }
 
      if (checked && checked.dataset.variantId) continue; // already valid
      if (!valid || valid === checked) continue;
 
      if (checked) checked.checked = false;
      valid.checked = true;
      valid.dispatchEvent(new Event('change', { bubbles: true }));
      return; // that change re-renders; the next pass handles the rest
    }
  }
 
  var pickers = document.querySelectorAll('variant-picker');
 
  for (var p = 0; p < pickers.length; p++) {
    (function (picker) {
      var timer;
 
      function schedule() {
        clearTimeout(timer);
        timer = setTimeout(function () {
          heal(picker);
        }, SETTLE_MS);
      }
 
      schedule();
 
      new MutationObserver(schedule).observe(picker, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['checked', 'data-variant-id']
      });
    })(pickers[p]);
  }
})();
 
 
/* TWD gallery pills — keep the active pill in sync on iPhone
   iOS Safari stops a swipe on a fractional scroll position (e.g. 879.6
   instead of 880), so the theme rounds down and leaves the last pill
   unlit. After each swipe settles, recompute the slide from the real
   scroll position and set the pills. Re-queried every time, so it keeps
   working after a variant change re-renders the gallery. */
(function () {
  var timer;
  document.addEventListener('scroll', function (e) {
    var s = e.target;
    if (!(s instanceof Element) || s.tagName !== 'SLIDESHOW-SLIDES' || !s.closest('media-gallery')) return;
    clearTimeout(timer);
    timer = setTimeout(function () {
      var w = s.clientWidth;
      var host = s.closest('slideshow-component');
      if (!w || !host) return;
      var dots = host.querySelectorAll('.slideshow-control[aria-selected]');
      if (!dots.length) return;
      var i = Math.min(Math.round(Math.abs(s.scrollLeft) / w), dots.length - 1);
      for (var n = 0; n < dots.length; n++) {
        dots[n].setAttribute('aria-selected', n === i ? 'true' : 'false');
      }
    }, 120);
  }, true);
})();
 
 
/* TWD — Arabic card carousels open at the wrong end on iPhone
   iOS Safari, RTL + scroll-snap "x mandatory": the carousel is already at
   its far end on first paint (scrollLeft -1155 of 1156, measured 7 Oct on
   Best Sellers) with no script involved — Safari picks the wrong snap
   position itself. Chrome starts correctly at 0.
   Fix: just before each carousel comes on screen, jump it to its start
   instantly (behavior 'instant' overrides the theme's smooth scrolling, so
   nothing visibly slides). Runs once per carousel, and never after the
   shopper has touched it. Arabic only; product galleries untouched. */
(function () {
  if (document.documentElement.dir !== 'rtl' || !('IntersectionObserver' in window)) return;
 
  function toStart(s) {
    if (s._twdTouched || Math.abs(s.scrollLeft) <= 2) return;
    s.scrollTo({ left: 0, behavior: 'instant' });
  }
 
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      toStart(e.target);
      io.unobserve(e.target);
    });
  }, { rootMargin: '400px 0px' });
 
  function watch(scope) {
    (scope || document).querySelectorAll('slideshow-slides').forEach(function (s) {
      if (s._twdWatched || s.closest('media-gallery')) return;
      if (!s.querySelector(':scope > .resource-list__slide')) return;
      s._twdWatched = true;
      ['touchstart', 'pointerdown', 'wheel'].forEach(function (ev) {
        s.addEventListener(ev, function () { s._twdTouched = true; }, { passive: true });
      });
      io.observe(s);
    });
  }
 
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { watch(); });
  else watch();
  document.addEventListener('shopify:section:load', function (e) { watch(e.target); });
})();
 
 
/* TWD — product cards open on their first image
   Browsers restore a card gallery's horizontal scroll on reload, so a card
   could open on slide 3. This used to be solved in custom.css §12 by hiding
   every slide but the first on phones — which also hid the image a swatch
   tap scrolls to, leaving the card blank. Reset the scroll instead, so
   swatches keep working. Runs on load and on back/forward (pageshow). */
(function () {
  function reset() {
    document.querySelectorAll('.card-gallery slideshow-slides').forEach(function (s) {
      if (Math.abs(s.scrollLeft) > 2) s.scrollTo({ left: 0, behavior: 'instant' });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', reset);
  else reset();
  window.addEventListener('pageshow', reset);
})();